var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBatteryChargingVertical = function SvgIconBatteryChargingVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.375 1.125a1 1 0 0 1 1-1h5.25a1 1 0 1 1 0 2h-5.25a1 1 0 0 1-1-1M12.929 9.559a1 1 0 0 0-1.857-.743l-1.5 3.75a1 1 0 0 0 .928 1.371h1.523l-.951 2.38a1 1 0 0 0 1.857.742l1.5-3.75a1 1 0 0 0-.929-1.371h-1.523z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.25 6a2.5 2.5 0 0 1 2.5-2.5h10.5a2.5 2.5 0 0 1 2.5 2.5v13.875a2.5 2.5 0 0 1-2.5 2.5H6.75a2.5 2.5 0 0 1-2.5-2.5zm2.5-.5a.5.5 0 0 0-.5.5v13.875a.5.5 0 0 0 .5.5h10.5a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconBatteryChargingVertical;